import { render, staticRenderFns } from "./Brt.vue?vue&type=template&id=6b4c9b91"
import script from "./Brt.vue?vue&type=script&lang=js"
export * from "./Brt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports